// extracted by mini-css-extract-plugin
export default {"modal-container":"ziha5","modalContainer":"ziha5","header":"zdEUg","modal-body":"VtSIk","modalBody":"VtSIk","image":"UexZu","title":"maI3d","btn":"xlRSM"};